import nanoajax from "nanoajax";
import slugify from "slugify";
import PubSub from "pubsub-js";
import Swiper from "swiper";
import { stretchTo, stretchFrom } from "../../../searchform";
import { getItemsOnBlog } from "../../../shared/utils";
import "../../../shared/pubsub-triggers";

export const createComponentsDestination = () => {
	if (document.body.className.match(`.destination-page`)) {
		const blogDestinosContent = document.querySelector(
			".blog-destino .swiper-container .swiper-wrapper"
		);
		const destinyCity = document.querySelector("#nameDestination").innerHTML;

		const limitPostsBlog = 5;
		let sizeBlog = 0;

		window.addEventListener("load", function() {
			PubSub.publish("dataLayer", {
				event: "ditoTrack",
				ditoTrack: {
					action: "acessou-cidade-destino",
					data: {
						cidade_destino: destinyCity
					}
				}
			});
		});

		const testeABNearbyPlaces = window.testeABNearbyPlaces;
		// Se testeABNearbyPlaces for FASE o teste A/B irá buscar pelo nearbyplaces (from, to)
		// Se testeABNearbyPlaces for TRUE o teste A/B não irá buscar pelo nearbyplaces (~from, ~to)
		if (!testeABNearbyPlaces) {
			const nearbyResponseElement = document.querySelector("#nearbyResponse");
			const nearbyResponseElementTravel = document.querySelector("#nearbyResponseTravel");
			const searchFormElement = document.querySelector("#searchForm");

			if (searchFormElement) {
				const nearbyStretchCreate = (nearbyResponseElement, stretchTo, stretchFrom) => {
					const airportData = JSON.parse(nearbyResponseElement.innerHTML);
					const stretch = nearbyResponseElement.getAttribute("strech") == "to" ? stretchTo : stretchFrom;
					const groupIATA = airportData.filter(airport => airport.group);

					if (groupIATA.length > 0) {
						stretch.decorateField(document.querySelector(`#${stretch.elm.id}`), {
							city: groupIATA[0].city,
							iata: groupIATA[0].group,
							name: "Todos",
							country: groupIATA[0].country == "Brazil" ? "BR" : "" //TODO - retornar países com abreviação de dois caracteres do banco
						});
					} else {
						stretch.decorateField(document.querySelector(`#${stretch.elm.id}`), {
							city: airportData[0].city,
							iata: airportData[0].iata,
							name: airportData[0].name,
							country: airportData[0].country == "Brazil" ? "BR" : ""
						});
					}
				};

				if (nearbyResponseElement) {
					nearbyStretchCreate(nearbyResponseElement, stretchTo, stretchFrom);
				}

				if (nearbyResponseElementTravel) {
					nearbyStretchCreate(nearbyResponseElementTravel, stretchTo, stretchFrom);
				}
			}
		}

		// BLOG
		nanoajax.ajax(
			{
				url: `https://www.maxmilhas.com.br/blog/?feed=rss2&s=${slugify(destinyCity)}`,
				method: "GET",
				cors: true,
			},
			function(code, responseText, request) {
				let data;

				document.querySelector(".blog-destino .loading").remove();

				if (code === 200 && responseText) {
					if (window.DOMParser) {
						const parser = new DOMParser();
						data = parser.parseFromString(responseText, "text/xml");
					} else {
						// Internet Explorer
						data = new ActiveXObject("Microsoft.XMLDOM");
						data.async = false;
						data.loadXML(responseText);
					}

					const channelXML = data.getElementsByTagName("channel")[0];

					const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

					const createItemsOnScreen = (channelXML, length) => {
						sizeBlog = length;

						for (var i = 0; i < limitPostsBlog; i++) {
							const item = channelXML.getElementsByTagName("item")[i];

							if (!item) {
								var swiperBlogFriday = new Swiper(".blog-destino .swiper-container", {
									pagination: {
										el: null,
										clickable: true
									},
									simulateTouch: false,
									loop: false,
									slidesPerView: sizeBlog,
									slidesPerGroup: sizeBlog,
									slidesPerColumn: 1,
									spaceBetween: 30,
									navigation: {
										nextEl: ".blog-destino .swiper-button-next",
										prevEl: ".blog-destino .swiper-button-prev",
									},
									breakpoints: {
										768: {
											pagination: {
												el: ".blog-destino .swiper-pagination",
											},
											simulateTouch: true,
											slidesPerView: 1,
											slidesPerGroup: 1,
											slidesPerColumn: 1,
											loop: true
										}
									}
								});

								return false;
							}
							
							let categoriesFields = [];
							for (const category of item.getElementsByTagName("category")) {
								categoriesFields.push(category.textContent);			
							}

							if (!_.contains(categoriesFields, 'Passagens aéreas')) {
								const title = item.getElementsByTagName("title")[0].textContent;
								const link = item.getElementsByTagName("link")[0].textContent;
								const image = item.getElementsByTagName("image")[0]
									? item.getElementsByTagName("image")[0].textContent
									: "<img width='355' height='237' src='../../../../img/defaults/img-default-770x305.jpg' class='attachment-image-372 size-image-372 wp-post-image' />";
								const description = item.getElementsByTagName("description")[0].textContent;

								let columns = "";

								if (length == 3) {
									columns = " col-md-4";
								} else if (length == 2 && i == 0) {
									columns = " col-md-4 col-md-offset-2";
								} else if (length == 2 && i != 0) {
									columns = " col-md-4";
								} else {
									columns = " col-md-3";
								}

								blogDestinosContent.innerHTML += `
								<div class="swiper-slide">
									<a href="${link.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}" class="card-largetitle blog" target="_blank">
											<div class="card-largetitle-item">
													<div class="card-largetitle-item--title">
															${image.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}
													</div>
													<div class="card-largetitle-item--info">
															<div class="card-largetitle-item--info-infos">
																	<h3>${title}</h3>
																	<p class="card-largetitle-item--info-text">
																	${description}</p>
															</div>
													</div>
											</div>
									</a>
								</div>`;
							}
						}

						sizeBlog = sizeBlog > 4 ? (sizeBlog = 4) : (sizeBlog = sizeBlog);

						var swiperBlogFriday = new Swiper(".blog-destino .swiper-container", {
							pagination: {
								el: null,
								clickable: true
							},
							simulateTouch: false,
							loop: false,
							slidesPerView: sizeBlog,
							slidesPerGroup: sizeBlog,
							slidesPerColumn: 1,
							spaceBetween: 30,
							navigation: {
								nextEl: ".blog-destino .swiper-button-next",
								prevEl: ".blog-destino .swiper-button-prev",
							},
							breakpoints: {
								768: {
									pagination: {
										el: ".blog-destino .swiper-pagination",
									},
									simulateTouch: true,
									slidesPerView: 1,
									slidesPerGroup: 1,
									slidesPerColumn: 1,
									loop: true
								}
							}
						});
					};

					if (length < 2) {
						nanoajax.ajax(
							{
								url: `https://www.maxmilhas.com.br/blog/?feed=rss2`,
								method: "GET",
								cors: true,
							}, 
							function(code, responseText, request) {
								if (window.DOMParser) {
									const parser = new DOMParser();
									data = parser.parseFromString(responseText, "application/xml");
								} else {
									// Internet Explorer
									data = new ActiveXObject("Microsoft.XMLDOM");
									data.async = false;
									data.loadXML(responseText);
								}

								const channelXML = data.getElementsByTagName("body")[0];

								const { length } = getItemsOnBlog(data.getElementsByTagName("channel")[0]);

								createItemsOnScreen(channelXML, length);
							}
						);
					} else {
						createItemsOnScreen(channelXML, length);
					}
				} else {
					blogDestinosContent.innerHTML += `<div class="col-xs-16">
              <a href="#" class="card-largetitle blog" target="_blank">
                  <div class="card-largetitle-item">
                      <div class="card-largetitle-item--title">
                          <img src="#" alt="">
                      </div>
                      <div class="card-largetitle-item--info">
                          <div class="card-largetitle-item--info-infos">
                              <h4>Ops!</h4>
                              <p class="card-largetitle-item--info-text">Ocorreu um erro, tente novamente.</p>
                          </div>
                      </div>
                  </div>
              </a>
          </div>`;
				}
			}
		);
	}
};
